












































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { getUnitVideos, getUnitList, VideoGroupPointData } from '@/api/videoDevice/play'
import { newGuid } from '@/configs/functions'

import { UserData } from '@/api/systemManage/user'
import { namespace } from 'vuex-class'
import { enUserType } from '@/configs/enums'
const UserModule = namespace('user')
@Component({
  components: {}
})
/**视频列表 */
export default class VideoList extends Vue {
  @UserModule.Getter('userInfo')
  public curUser!: UserData
  public get isUserCity(): boolean {
    var userType = this.curUser.UserType
    return userType == enUserType.CityHeritage || userType == enUserType.CityFinance
  }
  public get isUserProvince(): boolean {
    var userType = this.curUser.UserType
    return userType == enUserType.ProvinceHeritage || userType == enUserType.ProvinceFinance
  }
  @Prop({ default: null })
  public callPlay!: Function

  public listLoading: boolean = false
  public onlyOnline: boolean = false
  public list: any[] = []
  public queryTerm = {
    Page: 0,
    PageSize: 9999,
    SortBy: 'CityName',
    IsAsc: true,

    /**0全部 1离线 2在线 3未知 */
    OnlineStatus: 0,
    Keyword: ''
  }
  public created() {
  }
  public mounted() {
  }
  public expandKey: number[] = []
  public fetchVideo(row: any, expandedRows: any) {
    if (!row.childs || row.childs.length == 0) {
      row.childs = []
      row.loading = true
      var onlineStatus = this.onlyOnline ? 2 : 0
      getUnitVideos(row.UnitId, onlineStatus).then((response: { data: any }) => {
        const data = response.data
        if (data) {
          data.forEach((e: any, i: number) => {
            e.checked = false
          })
          row.childs = data
          row.loading = false
          var index = this.list.findIndex((v: any) => v.UnitId == row.UnitId)
          this.$set(this.list, index, row)
        }
      })
    }
  }

  public unitClick(e: any) {
    var index = this.expandKey.findIndex((v: number) => v == e.UnitId)
    if (index == -1) {
      this.expandKey = [e.UnitId]
      this.fetchVideo(e, null)
    }
    else {
      this.expandKey.splice(index, 1)
    }
  }
  public checkSub(index: number) {
    var item = this.list[index]
    var selectedChilds = item.childs.filter((v: any) => v.checked)
    if (selectedChilds.length == item.OnlineCount && item.checked == false) {
      item.checked = true
    }
  }
  public checkAll(index: number) {
    var item = this.list[index]
    item.childs.filter((v: any) => v.Online == 1).forEach((e: any, i: number) => {
      // if (e.Online == 1) {
      e.checked = item.checked
      // }
    })
  }
  public clearChecked() {
    this.list.forEach((e: any, i: number) => {
      e.checked = false
      // 这里e.childs需要判断下，有些没有展开的项，childs为null
      if (e.childs && e.childs.length > 0) {
        e.childs.forEach((f: any, j: number) => {
          f.checked = false
        })
      }
    })
  }
  public playVideo() {
    var codes: any[] = []
    this.list.forEach((e: any, i: number) => {
      if (e.childs && e.childs.length > 0) {
        var childs = e.childs.filter((v: any) => v.checked)
        if (childs && childs.length > 0) {
          childs.forEach((f: any, j: number) => {
            //只播放在线的视频
            if (f.Online == 1) {
              codes.push({ code: f.PointNumber, sm: f.StreamMode })
            }
          })
        }
      }
    })
    var count = codes.length
    if (count > window.hikVideoCount) {
      this.$message.warning('同时播放的视频数不能超过' + window.hikVideoCount + '个')
    }
    else if (count > 0) {
      if (this.callPlay) {
        this.callPlay(codes)
        this.clearChecked()
      }
    }
    else {
      this.$message.warning('请选择需要播放的视频')
    }
  }
  public targetId: string = ''
  public addGroup() {
    var points: VideoGroupPointData[] = []
    this.list.forEach((e: any, i: number) => {
      if (e.childs && e.childs.length > 0) {
        var childs = e.childs.filter((v: any) => v.checked)
        if (childs && childs.length > 0) {
          childs.forEach((f: any, j: number) => {
            //只播放在线的视频
            if (f.Online == 1) {
              points.push({
                Id: 0, GroupId: 0, GroupName: '', GroupSeq: 0, Sequence: 0, Online: f.Online,
                VideoPointId: f.Id, PointNumber: f.PointNumber, PointName: f.PointName, StreamMode: f.StreamMode
              })
            }
          })
        }
      }
    })
    var count = points.length
    if (count > window.hikVideoCount) {
      this.$message.warning('同时播放的视频数不能超过' + window.hikVideoCount + '个')
    }
    else if (count > 0) {
      if (this.targetId == '') {
        this.targetId = newGuid()
      }
      var data: any = { points: points, targetId: this.targetId }
      window.eventBus.$emit("openVideoGroupForm_points", data)

      this.clearChecked()
    }
    else {
      this.$message.warning('请选择需要保存的视频')
    }
  }
  //数据加载
  public loadData() {
    //触发控件的查询事件
    this.fetchData()
  }
  public doSearch() {
    this.fetchData()
  }
  public fetchData() {
    this.listLoading = true
    this.expandKey = []
    getUnitList(this.queryTerm).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        var items = data.Results
        items.forEach((e: any, i: number) => {
          e.checked = false
        })
        this.list = items

        /*
        //页面首次加载时，默认打开第一个节点
        if (this.expandKey.length == 0 && items.length > 0) {
          var row = items.find((v: any) => v.OnlineCount > 0)// units[0]
          if (row && row.UnitId > 0) {
            this.expandKey = [row.UnitId]
            this.fetchVideo(row, null)
          }
        }
        */
      }
      this.listLoading = false
    })
  }
  public onlineChange() {
    this.queryTerm.OnlineStatus = this.onlyOnline ? 2 : 0
    this.doSearch()
  }
  // 在当前路由改变，但是该组件被复用时调用
  @Watch('$route')
  public onRouteChange(route: any) {
  }
}
